const state = () => ({
    varietySelected: null,
    varietyPieSelected: null,
    disponiblePublico: window.customGeneral.show
});

const getters = {
    isDisponiblePublico(state) {
        return !!state.disponiblePublico;
    }
};

const actions = {};

const mutations = {
    setVarietySelected(state, variety) {
        state.varietySelected = variety;
    },
    setVarietyPieSelected(state, variety) {
        state.varietyPieSelected = variety;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
